/**
 * Preserve Shopify embed context query params (host/shop/embedded)
 * across client-side navigation.
 *
 * This helps prevent auth/shop resolution issues when the app is opened
 * top-level (not in an iframe) where window.shopify may not be present.
 */

const PRESERVED_KEYS = ['host', 'shop', 'embedded'] as const;

export function withShopifyContext(path: string): string {
  if (typeof window === 'undefined') return path;

  let url: URL;
  try {
    url = new URL(path, window.location.origin);
  } catch {
    return path;
  }

  const current = new URLSearchParams(window.location.search);

  for (const key of PRESERVED_KEYS) {
    const v = current.get(key);
    if (v && !url.searchParams.has(key)) {
      url.searchParams.set(key, v);
    }
  }

  return `${url.pathname}${url.search}${url.hash}`;
}
